import {Modal} from 'react-bootstrap'
import {useIntl} from 'react-intl'
import {useState} from 'react'
import RectangularTabs from '../../../widgets/components/RectangularTabs'
import GenerateReportExistingTemplate from './GenerateReportExistingTemplate'
import GenerateNewReport from './GenerateNewReport'

const GenerateReportModal = ({isActive, setIsActive, templateId, setTabKey,getAllTemplate}: any) => {
  const {formatMessage} = useIntl()
  const options = [
    {
      id: 1,
      slug: '',
      title: formatMessage({id: 'Using Existing Templates'}),
      subTitle: formatMessage({id: 'Select Predefined templates to generate report'}),
    },
    {
      id: 2,
      slug: '',
      title: formatMessage({id: 'New Report'}),
      subTitle: formatMessage({id: 'Select parameters as per your need to generate report'}),
    },
  ]

  const [selectedTab, setSelectedTab] = useState<number>(1)

  const handleTabChange = (id: number) => {
    setSelectedTab(id)
  }

  return (
    <Modal show={isActive} onHide={() => setIsActive(false)} size='lg' fullscreen>
      <Modal.Header closeButton>
        <h2>{formatMessage({id: 'Generate Report'})}</h2>
      </Modal.Header>
      <Modal.Body>
        <div className='container'>
          <RectangularTabs
            options={options}
            selectedTab={selectedTab}
            handleTabChange={handleTabChange}
            isDisabled={templateId}
          />
          <div className='my-auto w-100 mt-4'>
            {selectedTab === 1 && (
              <GenerateReportExistingTemplate
                setIsActive={setIsActive}
                existingTemplateId={templateId}
                setTabKey={setTabKey}
                getAllTemplate={getAllTemplate}
              />
            )}
            {selectedTab === 2 && <GenerateNewReport setIsActive={setIsActive}    getAllTemplates={getAllTemplate} />}
          </div>
        </div>
      </Modal.Body>
      {/* <Modal.Footer>
        <div className='d-md-flex w-100 justify-content-end px-md-6 px-0 gap-3'>
          <button type='button' className='btn btn-light text-muted w-auto'>
            {formatMessage({ id: 'Cancel' })}
          </button>

          <button type='submit' className=' btn btn-primary w-auto'>
            {formatMessage({ id: 'Generate Report' })}
          </button>
        </div>
      </Modal.Footer> */}
    </Modal>
  )
}

export default GenerateReportModal
